import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Package translations
import { commonEn, commonFi } from '@viilutalous/common';
import { dashboardEn, dashboardFi } from '@viilutalous/dashboard';
import { accountingEn, accountingFi } from '@viilutalous/accounting';
import { customersEn, customersFi } from '@viilutalous/customers';
import { crmEn, crmFi } from '@viilutalous/crm';
import { inventoryEn, inventoryFi } from '@viilutalous/inventory';
import { purchasingEn, purchasingFi } from '@viilutalous/purchasing';
import { invoicingEn, invoicingFi } from '@viilutalous/invoicing';
import { contractInvoicingEn, contractInvoicingFi } from '@viilutalous/contract-invoicing';
import { bankEn, bankFi } from '@viilutalous/banking';
import { salariesEn, salariesFi } from '@viilutalous/salaries';
import { adminEn, adminFi } from '@viilutalous/admin';
import { salesEn, salesFi } from '@viilutalous/sales';
import { projectsEn, projectsFi } from '@viilutalous/projects';
import { timeTrackingEn, timeTrackingFi } from '@viilutalous/time-tracking';
import { helpdeskEn, helpdeskFi } from '@viilutalous/helpdesk';
import { knowledgebaseEn, knowledgebaseFi } from '@viilutalous/knowledgebase';
import { webhooksEn, webhooksFi } from '@viilutalous/webhooks';
import { meteredBillingEn, meteredBillingFi } from '@viilutalous/metered-billing';
import { biEn, biFi } from '@viilutalous/bi';
import { storeEn, storeFi } from '@viilutalous/store';
import { companyEn, companyFi } from '@viilutalous/company';

// Local translations (no package)
import settingsEn from './locales/settings/en';
import settingsFi from './locales/settings/fi';
import authEn from './locales/auth/en';
import authFi from './locales/auth/fi';
import changelogEn from './locales/changelog/en';
import changelogFi from './locales/changelog/fi';
import sendingServiceEn from './locales/sending-service/en';
import sendingServiceFi from './locales/sending-service/fi';
import { maventaEn, maventaFi } from '@viilutalous/biz-maventa';
import employeesEn from './locales/employees/en';
import employeesFi from './locales/employees/fi';
import expensesEn from './locales/expenses/en';
import expensesFi from './locales/expenses/fi';
import navEn from './locales/nav/en';
import navFi from './locales/nav/fi';
import meEn from './locales/me/en';
import meFi from './locales/me/fi';

const resources = {
  en: {
    translation: {
      ...commonEn,
      ...dashboardEn,
      ...accountingEn,
      ...customersEn,
      ...crmEn,
      ...inventoryEn,
      ...purchasingEn,
      ...invoicingEn,
      ...contractInvoicingEn,
      ...bankEn,
      ...salariesEn,
      ...adminEn,
      ...salesEn,
      ...projectsEn,
      ...timeTrackingEn,
      ...helpdeskEn,
      ...knowledgebaseEn,
      ...webhooksEn,
      ...meteredBillingEn,
      ...biEn,
      ...storeEn,
      ...companyEn,
      ...settingsEn,
      ...authEn,
      ...changelogEn,
      ...sendingServiceEn,
      ...maventaEn,
      ...employeesEn,
      ...expensesEn,
      ...navEn,
      ...meEn,
    },
  },
  fi: {
    translation: {
      ...commonFi,
      ...dashboardFi,
      ...accountingFi,
      ...customersFi,
      ...crmFi,
      ...inventoryFi,
      ...purchasingFi,
      ...invoicingFi,
      ...contractInvoicingFi,
      ...bankFi,
      ...salariesFi,
      ...adminFi,
      ...salesFi,
      ...projectsFi,
      ...timeTrackingFi,
      ...helpdeskFi,
      ...knowledgebaseFi,
      ...webhooksFi,
      ...meteredBillingFi,
      ...biFi,
      ...storeFi,
      ...companyFi,
      ...settingsFi,
      ...authFi,
      ...changelogFi,
      ...sendingServiceFi,
      ...maventaFi,
      ...employeesFi,
      ...expensesFi,
      ...navFi,
      ...meFi,
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fi',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
